/**
 * @fileoverview Spinner — yükleme göstergesi.
 * fullScreen prop: tüm ekranı kaplar (Suspense fallback)
 * inline prop:     satır içi küçük spinner
 */

import { cn } from '../../utils/cn'

/**
 * @param {{
 *   fullScreen?: boolean,
 *   size?:       'sm' | 'md' | 'lg',
 *   className?:  string,
 * }} props
 */
export default function Spinner({ fullScreen = false, size = 'md', className }) {
  const sizeMap = {
    sm: 'w-5 h-5 border-2',
    md: 'w-9 h-9 border-2',
    lg: 'w-14 h-14 border-[3px]',
  }

  const spinner = (
    <span
      role="status"
      aria-label="Yükleniyor"
      className={cn(
        'block rounded-full animate-spin',
        'border-white/10',
        sizeMap[size] ?? sizeMap.md,
        className
      )}
      style={{
        borderTopColor: '#BF953F',
        borderRightColor: '#FCF6BA',
      }}
    />
  )

  if (fullScreen) {
    return (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-[#0D172A]/80 backdrop-blur-sm"
        aria-live="polite"
      >
        <div className="flex flex-col items-center gap-4">
          {spinner}
          <p
            className="text-[10px] uppercase tracking-[0.3em] text-[#BF953F]"
            style={{ fontFamily: '"DM Sans", system-ui, sans-serif' }}
          >
            Yükleniyor
          </p>
        </div>
      </div>
    )
  }

  return spinner
}
